import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pagination } from "antd";
import moment from "moment";

import MeetingTopPart from "./meeting-top-part";

import { MeetingAction } from "../../store/actions";

import {
  tables,
  StatusIndicator,
  boxContainer,
  Spacer,
} from "../../components";

function MeetingsSent() {
  const dispatch = useDispatch();

  const { meetingSent, meetingSentCount, isMeetingSentLoading } = useSelector(
    (state) => state.meeting
  );

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [pageNo, setPageNo] = useState(1);

  useEffect(() => {
    fetchMeeting();
  }, [pageNo]);

  const fetchMeeting = () => {
    const meetingPayload = {
      limit,
      offset,
    };
    dispatch(MeetingAction.getMeetingRequests(meetingPayload));
    dispatch(MeetingAction.getAllMeetingsAndCount());
  };

  const handlePagination = (pagenumber) => {
    setOffset((pagenumber - 1) * limit);
    setPageNo(pagenumber);
  };

  const columns = [
    {
      title: "Student",
      key: "0",
      width: 200,
      align: "center",
      render: (text, record) => (
        <div>
          {record?.userStudent?.firstName} {record?.userStudent?.lastName}
        </div>
      ),
    },
    {
      title: "Subject",
      key: "1",
      width: 150,
      align: "center",
      render: (text, record) => <div>{record?.subject}</div>,
    },
    {
      title: "Meeting Date",
      key: "2",
      width: 100,
      align: "center",
      render: (text, record) => (
        <div>
          {record?.status === "rescheduled" ? (
            <div className="flex flex-col gap-2 justify-center items-center">
              <StatusIndicator
                showarrow={false}
                text={
                  <div>
                    {moment(record?.meetingDatePrev).format("DD MMM, YYYY")}{" "}
                    <span className="text-[0.625em] font-semibold ml-2">
                      Previous Date
                    </span>
                  </div>
                }
                color="yellow"
              />
              <StatusIndicator
                showarrow={false}
                text={
                  <div>
                    {moment(record?.meetingDate).format("DD MMM, YYYY")}{" "}
                    <span className="text-[0.625em] font-semibold ml-2">
                      New Date
                    </span>
                  </div>
                }
                color="green"
              />
            </div>
          ) : (
            <div>{moment(record?.meetingDate).format("DD MMM, YYYY")}</div>
          )}
        </div>
      ),
    },
    {
      title: "Meeting Time",
      key: "3",
      width: 130,
      align: "center",
      render: (text, record) => (
        <div>
          {record?.status === "rescheduled" ? (
            <div className="flex flex-col gap-2 justify-center items-center">
              <StatusIndicator
                showarrow={false}
                text={
                  <div>
                    {record?.timeSlotPrev?.timeSlot}{" "}
                    <span className="text-[0.625em] font-semibold ml-2">
                      Previous Date
                    </span>
                  </div>
                }
                color="yellow"
              />
              <StatusIndicator
                showarrow={false}
                text={
                  <div>
                    {record?.timeSlot?.timeSlot}{" "}
                    <span className="text-[0.625em] font-semibold ml-2">
                      New Date
                    </span>
                  </div>
                }
                color="green"
              />
            </div>
          ) : (
            <div>{record?.timeSlot?.timeSlot}</div>
          )}
        </div>
      ),
    },
    {
      title: "Meeting Status",
      key: "4",
      width: 50,
      align: "center",
      render: (text, record) => (
        <div className="flex items-center justify-center">
          <StatusIndicator
            showarrow={false}
            text={record?.status}
            color={
              record?.status === "accepted"
                ? "green"
                : record?.status === "pending"
                ? "yellow"
                : "blue"
            }
          />
        </div>
      ),
    },
  ];
  return (
    <div className="text-black">
      <boxContainer.LiteBoxContainer>
        <MeetingTopPart />
        <Spacer height={20} />
        <tables.MeetingTable
          columns={columns}
          data={meetingSent}
          rowKey={(record) => record.id}
          loading={isMeetingSentLoading}
        />
        <div className="flex justify-center items-center p-3">
          <Pagination
            responsive="true"
            showSizeChanger={false}
            hideOnSinglePage={false}
            current={pageNo}
            pageSize={limit}
            total={meetingSentCount}
            onChange={handlePagination}
          />
        </div>
      </boxContainer.LiteBoxContainer>
    </div>
  );
}
export default MeetingsSent;
